import { render, staticRenderFns } from "./promoters.vue?vue&type=template&id=0d4d7176&scoped=true"
import script from "./promoters.vue?vue&type=script&lang=js"
export * from "./promoters.vue?vue&type=script&lang=js"
import style0 from "./promoters.vue?vue&type=style&index=0&id=0d4d7176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d7176",
  null
  
)

export default component.exports